import { createReducer, on } from '@ngrx/store';
import { materialTypesActions } from '../actions/material-types.actions';
import { Material, MaterialType } from '../models';

export interface MaterialTypesState {
    loaded: boolean | null;
    materialTypes: MaterialType[];
    materialsLoading: boolean;
    materials: Material[];
}

export const initialState: MaterialTypesState = {
    loaded: null,
    materialTypes: [],
    materialsLoading: false,
    materials: [],
};

export const materialTypesReducer = createReducer(
    initialState,
    on(materialTypesActions.getMaterialTypesSuccess, (state, { payload }): MaterialTypesState => ({ ...state, loaded: true, materialTypes: payload })),
    on(materialTypesActions.getMaterialTypesError, (state): MaterialTypesState => ({ ...state, loaded: false })),
    on(materialTypesActions.getMaterials, (state): MaterialTypesState => ({ ...state, materialsLoading: true, materials: [] })),
    on(materialTypesActions.getMaterialsSuccess, (state, { payload }): MaterialTypesState => ({ ...state, materialsLoading: false, materials: payload })),
    on(materialTypesActions.getMaterialsError, (state): MaterialTypesState => ({ ...state, materialsLoading: false })),
    on(materialTypesActions.clear, (): MaterialTypesState => ({ ...initialState })),
);
